import { createFileRoute } from '@tanstack/react-router'
import { AreaTrash } from '@components'

export const Route = createFileRoute('/areaManagement_/trash/')({
  component: () => <AreaTrash />,
})
